import { keycloak } from '../../services/keycloak'

const LoginScreen = () => {
  const handleLogin = () => {
    keycloak.login()
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <h1 className="text-2xl font-bold mb-4">Management Portal</h1>
        <p className="text-gray-600 mb-6">Please sign in to continue</p>
        <button
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          onClick={handleLogin}
        >
          Sign In
        </button>
      </div>
    </div>
  )
}

export default LoginScreen
